import { render, staticRenderFns } from "./Imofalform5Grid.vue?vue&type=template&id=e7a982a4"
import script from "./Imofalform5Grid.vue?vue&type=script&lang=js"
export * from "./Imofalform5Grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports